import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const Item = styled.li`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 10px;
  gap: 5px;

  border-radius: ${props => props.theme.radii.medium};
  background: ${props => props.theme.brand.surface};
  border: 1.5px solid rgba(23, 26, 29, 0.08);

  @media screen and (min-width: 768px) {
    padding: 15px;
    gap: 10px;
  }
`;

export const GoodWrap = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 4px;

  @media screen and (min-width: 768px) and (max-width: 1279px) {
    display: grid;
    grid-template-columns: 44px 1fr auto auto;
    grid-template-rows: auto auto;
    column-gap: 10px;
    row-gap: 6px;
    align-items: center;
  }

  @media screen and (min-width: 1280px) {
    gap: 14px;
  }
`;

export const Image = styled.img`
  width: 42px;
  height: 42px;
  flex-shrink: 0;
  border-radius: ${props => props.theme.radii.small};
  background: ${props => props.theme.brand.canvas};
  object-fit: contain;

  @media screen and (min-width: 768px) and (max-width: 1279px) {
    width: 44px;
    height: 44px;
    grid-column: 1;
    grid-row: 1 / 3;
    align-self: start;
  }

  @media screen and (min-width: 1280px) {
    width: 60px;
    height: 60px;
  }
`;

export const GoodName = styled(Link)`
  width: 68px;
  height: 48px;
  overflow: hidden;
  font-family: ${props => props.theme.fonts.body};
  font-size: 10px;
  color: ${props => props.theme.colors.textPrimary};

  @media screen and (min-width: 768px) and (max-width: 1279px) {
    grid-column: 2 / 5;
    grid-row: 1;
    width: auto;
    min-width: 0;
    height: auto;
    font-size: 12px;
    line-height: 1.3;
  }

  @media screen and (min-width: 1280px) {
    width: 138px;
    height: 52px;
    font-size: 14px;
  }

  &:hover {
    text-decoration: underline;
  }
`;

export const QuantityWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  flex-shrink: 0;

  @media screen and (min-width: 768px) and (max-width: 1279px) {
    grid-column: 2;
    grid-row: 2;
    justify-self: start;
    gap: 4px;
  }

  @media screen and (min-width: 1280px) {
    gap: 5px;
  }
`;

export const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  padding: 0;
  flex-shrink: 0;
  border-radius: 50%;
  background-color: ${props => props.theme.colors.secondary};
  color: ${props => props.theme.colors.textPrimary};
  transition: ${props => props.theme.transition.main};

  &:hover {
    background-color: ${props => props.theme.colors.hoverColor};
  }

  & svg {
    width: 8px;
    height: 8px;
    z-index: 2;
  }

  @media screen and (min-width: 768px) and (max-width: 1279px) {
    width: 24px;
    height: 24px;

    & svg {
      width: 9px;
      height: 9px;
    }
  }

  @media screen and (min-width: 1280px) {
    width: 30px;
    height: 30px;

    & svg {
      width: 11px;
      height: 11px;
    }
  }
`;

export const Input = styled.input`
  width: 44px;
  flex-shrink: 0;
  border-radius: ${props => props.theme.radii.pill};
  border: 1.5px solid rgba(23, 26, 29, 0.08);
  outline: none;
  padding: 4px 6px;
  text-align: center;
  font-family: ${props => props.theme.fonts.body};
  font-size: 10px;
  font-weight: 600;
  color: ${props => props.theme.colors.textPrimary};
  background: ${props => props.theme.brand.canvas};

  &:focus {
    border-color: ${props => props.theme.colors.secondary};
  }

  @media screen and (min-width: 768px) and (max-width: 1279px) {
    width: 42px;
    height: 24px;
    padding: 4px 6px;
    font-size: 11px;
  }

  @media screen and (min-width: 1280px) {
    width: 60px;
    height: 30px;
    padding: 6px 10px;
    font-size: 13px;
  }
`;

export const Price = styled.p`
  margin: 0 auto;
  flex-shrink: 0;
  font-family: ${props => props.theme.fonts.body};
  font-size: 10px;
  font-weight: 700;
  color: ${props => props.theme.colors.textPrimary};

  @media screen and (min-width: 768px) and (max-width: 1279px) {
    grid-column: 3;
    grid-row: 2;
    justify-self: end;
    margin: 0;
    white-space: nowrap;
    font-size: 12px;
  }

  @media screen and (min-width: 1280px) {
    font-size: 15px;
  }
`;

export const DeleteBtn = styled.button`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  background: transparent;

  & svg {
    width: 16px;
    height: 16px;
    fill: ${props => props.theme.brand.muted};
    transition: ${props => props.theme.transition.main};

    &:hover {
      fill: ${props => props.theme.colors.error};
    }
  }

  @media screen and (min-width: 768px) and (max-width: 1279px) {
    grid-column: 4;
    grid-row: 2;
    justify-self: end;

    & svg {
      width: 17px;
      height: 17px;
    }
  }

  @media screen and (min-width: 1280px) {
    & svg {
      width: 22px;
      height: 22px;
    }
  }
`;

export const CapacityWrap = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-right: auto;
  margin-left: 42px;
  gap: 5px;

  @media screen and (min-width: 768px) and (max-width: 1279px) {
    gap: 6px;
    margin-left: 52px;
  }

  @media screen and (min-width: 1280px) {
    gap: 8px;
    margin-left: 60px;
  }
`;

export const Capacity = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 2px 8px;
  border-radius: ${props => props.theme.radii.pill};
  background: ${props => props.theme.brand.canvas};
  font-family: ${props => props.theme.fonts.body};
  font-size: 8px;
  font-weight: 600;
  color: ${props => props.theme.brand.muted};

  @media screen and (min-width: 768px) {
    font-size: 11px;
    padding: 3px 10px;
  }
`;

export const SealingHolders = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 2px 8px;
  border-radius: ${props => props.theme.radii.pill};
  background: rgba(111, 143, 91, 0.1);
  font-family: ${props => props.theme.fonts.body};
  font-size: 8px;
  font-weight: 600;
  color: ${props => props.theme.colors.success};

  @media screen and (min-width: 768px) {
    font-size: 11px;
    padding: 3px 10px;
  }
`;

export const Advert = styled.div`
  font-family: ${props => props.theme.fonts.body};
  font-size: 10px;
  margin-top: 4px;
  margin-left: 4px;
  color: ${props => props.theme.colors.error};

  @media screen and (min-width: 768px) {
    font-size: 14px;
  }
`;
